/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import { scrollToAnchor } from "../../../theme/commonStyle";
import { Theme } from "@mui/material";

const trafficAccidentCheckinStyle = {
  scrollToAnchor,
  formPaper: {
    padding: { xs: "20px", lg: "20px 40px" },
  },
  gridSpaceAccusation: (theme: Theme) => ({
    [theme.breakpoints.up("sm")]: {
      paddingRight: "3rem",
    },
  }),
  gridSpaceEmail: (theme: Theme) => ({
    [theme.breakpoints.up("md")]: {
      paddingRight: "3rem",
    },
  }),
  buttonContainer: {
    marginRight: "auto",
    marginLeft: "auto",
  },
  heading: {
    textAlign: "center",
  },
  button: {
    marginTop: "25px",
  },
  classification: {
    width: "100%",
  },
  email: {
    width: "100%",
  },
  default: {
  },
  grey: {
    backgroundColor: "background.contrast",
  },
};

export default trafficAccidentCheckinStyle;
